enum Paths {
    donation = '/donations',
    donationCreate = '/donations/create',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/Donation/paths.ts